import {
  Col,
  Flex,
  message,
  Row,
  Tag,
  Timeline,
  Input,
  Dropdown,
  Tooltip,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import FileUploadModal from "./FileUploadModal";
import CustomTitle from "../../components/CustomTitle";
import { GetShipmentsViewers } from "../../api's/shipment";
import {
  ExclamationCircleFilled,
  LeftOutlined,
  RightOutlined,
  MinusOutlined,
  CloseOutlined,
  FullscreenOutlined,
  WarningFilled,
  CheckOutlined,
} from "@ant-design/icons";
import ShareIcon from "../../assets/images/share-icon.svg";
import EditIcon from "../../assets/images/edit-icon.svg";
import shipmentWebSocketService from "../../context/shipmentWebSocketService";
import ArchiveOptionsIcon from "../../assets/images/archiveOptions.svg";
import { ArchiveIcon, CheckmarkIcon } from "../../assets/icons/icons";
import DeleteBlackIcon from "../../assets/images/delete-black.svg";
import {
  CustomParagraph,
  CustomButton,
  CustomImage,
  CustomModalWithoutButton,
} from "../../components";
import {
  GoogleMapsProvider,
  useGoogleMaps,
} from "../../components/GoogleMapsProvider";
import { GoogleMap, Marker } from "@react-google-maps/api";
import StatusCardNotification from "../../components/StatusCardNotification";
import CustomModal from "../../components/CustomModal";
import ShareShipment from "../Modals/ShareShipment";
import ShipmentMap from "./ShipmentMap";
import { useNavigate } from "react-router-dom";
import { useSpin } from "../../components/SpinContext";
import {
  ArchiveShipment,
  GetShipmentAlerts,
  GetSingleShipment,
  MarkAsDelivered,
  ResolveAlertComments,
  ResolvedAlert,
} from "../../api's/shipment";
import { useToken, appHelper } from "../../common/helper";
import { ChainOfCustodyComments } from "../../api's/shipment";
import temp from "../../assets/images/temp.png";
import battery from "../../assets/images/battery.png";
import AtRisk from "../../assets/images/yellow Avatar.png";
import CommentIcon from "../../assets/images/comment.png";
import UploadIcon from "../../assets/images/uploadIcon.svg";
import FileDownload from "../../assets/images/fileDownload.svg";
import tempratureIcon from "../../assets/images/temprature-icon.svg";
import lightIcon from "../../assets/images/lightIcon.svg";
import humidityIcon from "../../assets/images/humidityIcon.svg";
import batteryIcon from "../../assets/images/battery-icon.svg";
import time from "../../assets/images/time.png";
import TemperatureModal from "../Modals/TempratureModal";
import BatteryModal from "../Modals/BatteryModal";
import FileImg from "../../assets/images/FILE.png";
import BlackIcon from "../../assets/images/Avatar.png";
import CriticalImage from "../../assets/images/Artwork trailing.png";
import ShipmentCommentBox from "./ShipmentCommentBox";
import HumidityModal from "../Modals/HumidityModal";
import LightModal from "../Modals/LightModal";
import CircleGroup from "./CircleGroup";
const dummyFileUrl = "https://example.com/dummy-file.pdf";
const { TextArea } = Input;

const TagColor = {
  0: "#FFF0EE",
  1: "#FDF2DC",
  2: "#EAF6ED",
  3: "#28a745",
  4: "#F3F3F3",
};

const TextColor = {
  0: "#DE1135",
  1: "#9F6402",
  2: "#0E8345",
  3: "#fff",
  4: "#4b4b4b",
};

function ShipmentDetailDrawer({
  isOpen,
  toggleDrawer,
  shipmentId,
  shipmentSuccess,
  drawerState,
}) {
  const { showSpin, hideSpin } = useSpin();
  const { token, removeToken, decodedUserToken, getUserID } = useToken();
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  let decodedToken = decodedUserToken();
  const { capitalize, formatDateToDayMonthYear, changeToTimeString } =
    appHelper();
  const [openCommentInput, setOpenCommentInput] = useState(false);
  const [openAlertInput, setOpenAlertInput] = useState(false);
  const [comments, setComments] = useState("");
  const [alertComment, setAlertComment] = useState("");
  const [isResolved, setIsResolved] = useState(true);
  const [commentsInputError, setCommentsInputError] = useState(false);
  const [lastPoint, setLastPoint] = useState(null);
  const [alertsData, setAlertsData] = useState(null);
  const [alertType, setAlertType] = useState(null);
  const [alertID, setAlertID] = useState();

  const [tempratureModalOpen, setTempratureModalOpen] = useState();
  const [batteryModalOpen, setBatteryModalOpen] = useState();

  //all states for alerts Array
  const [alertsArray, setAlertsArray] = useState([]);
  const [alertIndex, setAlertIndex] = useState(0);
  const [startAlertsInterval, setStartAlertsInterval] = useState(true);
  const navigate = useNavigate();
  const { isLoaded } = useGoogleMaps();
  const [shareShipmentModalOpen, setShareShipmentModalOpen] = useState(false);
  const [deleteShipmentModalOpen, setDeleteShipmentModalOpen] = useState(false);
  const [lightModalOpen, setLightModalOpen] = useState(false);
  const [humidityModalOpen, setHumidityModalOpen] = useState(false);
  const [shipment, setShipment] = useState({});
  const [viewers, setViewers] = useState([]);


  useEffect(() => {
    const fetchViewers = () => {
      GetShipmentsViewers(token, shipmentId)
        .then((res) => {
          const data = res?.data ? res.data : null;
          if (data) {
            if (data?.data?.is_success) {
              setViewers(data?.data?.data);
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    };

    fetchViewers();
    const interval = setInterval(() => {
      fetchViewers();
    }, 30000);

    return () => clearInterval(interval);
  }, [shipmentId, token]);

  useEffect(() => {
    if (token && shipmentId) {
      const baseDomain = process.env.REACT_APP_WEB_SOCKETS
      const wsUrl = `${baseDomain}/shipment/123/?shipmentId=${shipmentId}&token=${token}`;
      
      shipmentWebSocketService.connect(wsUrl);
    }

    return () => {
      shipmentWebSocketService.disconnect();
    };
  }, [token, shipmentId]);

  const handleShareShipmentModal = () => {
    setShareShipmentModalOpen(true);
  };

  // const handleDeleteShipmentModal = () => {
  //     console.log('clicked')
  //     setDeleteShipmentModalOpen(true);
  // }
  // const handleToggleAlertInput = () => {
  //     setOpenAlertInput(false)
  //     setAlertComment('')
  //     setAlertID(null);
  //     setAlertIndex(alertsArray.length>0 ? 0 : -1);
  //     getShipmentAlerts();
  //     setStartAlertsInterval(true);
  //     fetchSingleShipmentData();
  // }

  const handleEditShipmentModal = () => {
    //openShipmentModal();
    toggleDrawer("open", "Edit", shipmentId);
  };
  const goToExternalView = () => {
    navigate(`/shipment/external-view/${shipmentId}`);
  };

  const onAddCommentClick = () => {
    setOpenCommentInput(true);
    resetComments();
  };

  const resolvedAlert = () => {
    if (alertsData && alertsData?.id) {
      ResolvedAlert(token, alertsData?.id)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              setAlertType(null);
              // onAddCommentClick();
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    }
  };

  const onTextareaChange = (e) => {
    let val = e.target.value;
    if (val) {
      setComments(val);
    }
  };

  // const onAlertTextareaChange = (e) => {
  //     let val = e.target.value
  //     if (val) {
  //         setAlertComment(val);
  //     }
  // }

  const onSubmitComments = () => {
    if (comments) {
      let model = {
        chain_of_custody: shipmentId,
        comment: comments,
      };
      if (alertID) {
        model.alert_id = alertID;
      }
      ChainOfCustodyComments(token, model)
        .then((res) => {
          const data = res?.data || null;
          if (data) {
            if (data?.data?.is_success) {
              onCancelComments();
              fetchSingleShipmentData();
              setOpenAlertInput(false);
              setAlertID(null);
            } else {
              message.error(data?.data?.message);
            }
          }
        })
        .catch((error) => {
          unauthorize(error);
        })
        .finally(() => {
          hideSpin();
        });
    } else {
      setCommentsInputError(true);
    }
  };

  // const onSubmitAlertComment = () => {
  //     let model = {
  //         is_resolved: isResolved,
  //         pk_list: [alertID],
  //         comment: alertComment
  //     };

  //     ResolveAlertComments(token, model)
  //         .then((res) => {
  //             const data = res?.data || null;
  //             if (data) {
  //                 if (data?.data?.is_success) {
  //                     handleToggleAlertInput();
  //                     // setAlertIndex(alertsArray.length>0 ? 0 : -1)
  //                     // fetchSingleShipmentData();
  //                     // getShipmentAlerts();
  //                 } else {
  //                     message.error(data?.data?.message);
  //                 }
  //             }
  //         })
  //         .catch((error) => {
  //             unauthorize(error);
  //         }).finally(() => {
  //             hideSpin();
  //         });

  // }

  const resetComments = () => {
    setComments("");
    setCommentsInputError(false);
  };

  const onCancelComments = () => {
    setOpenCommentInput(false);
    resetComments();
  };

  useEffect(() => {
    if (isOpen) {
      setShipment(null);
      setLastPoint(null);
      fetchSingleShipmentData();
    }
  }, [isOpen, shipmentId]);

  const fetchSingleShipmentData = (isSpin = true) => {
    let t = localStorage.getItem("@token")
    if (isSpin) {
      showSpin();
    }
    GetSingleShipment(t, shipmentId)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              setShipment(resp);
              if (resp?.shipment_monitor && resp?.shipment_monitor.length > 0) {
                let lp =
                  resp.shipment_monitor[resp.shipment_monitor.length - 1];
                let newPoint = {
                  lat: lp.latitude, // Assuming the property name is 'latitude'
                  lng: lp.longitude, // Assuming the property name is 'longitude'
                };
                setLastPoint(newPoint);
              }
            }
          } else {
            // message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  useEffect(() => {
    if (isOpen) {
      getShipmentAlerts();
    }
  }, [isOpen, shipmentId]);

  // <------------Functions relative to alerts array------------>

  //Alerts Array call
  const getShipmentAlerts = () => {
    // showSpin();
    GetShipmentAlerts(token, shipmentId)
      .then((res) => {
        const data = res?.data ? res.data : null;
        if (data) {
          if (data?.data?.is_success) {
            let resp = data?.data?.data ? data?.data?.data : null;
            if (resp) {
              let arr = [];

              // if (resp?.critical && resp?.critical.length > 0) {
              //     resp?.critical.forEach(element => {
              //         arr.push(element)
              //     });
              // }
              // if (resp?.at_risk && resp?.at_risk.length > 0) {
              //     resp?.at_risk.forEach(element => {
              //         arr.push(element)
              //     });
              // }
              setAlertsArray(resp);
              // setAlertIndex(0)
              setAlertsData(resp);
              setAlertType(resp.alert_type);
            }
          } else {
            // message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };

  //use effect to run for alerts Array
  useEffect(() => {
    const fetchShipmentAlertData = () => {
      if (isOpen) {
        getShipmentAlerts();
        fetchSingleShipmentData(false);
      }
    };
    if (startAlertsInterval) {
      const intervalId = setInterval(() => {
        fetchShipmentAlertData();
      }, 30000);
      return () => clearInterval(intervalId);
    }
  }, [isOpen, shipmentId, startAlertsInterval]);

  //when mark as resolved or dismiss gets clicked
  const handleAlertResolved = (val, id) => {
    setIsResolved(val);
    setAlertID(id);
    setOpenAlertInput(true);
    setStartAlertsInterval(false);
  };
  const downloadFile = (fileUrl) => {
    if (!fileUrl) {
      message.error("File not found!");
      return;
    }

    // Create a temporary link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "file"); // ⚡ Ensures the file is downloaded, not opened
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up the DOM
  };

  //alerts fuction when comment cancel clicks or submit is  successful
  const handleToggleAlertInput = () => {
    setOpenAlertInput(false);
    setAlertComment("");
    setAlertID(null);
    setStartAlertsInterval(true);
  };

  //when comments inut for alert enter
  const onAlertTextareaChange = (e) => {
    let val = e.target.value;
    if (val) {
      setAlertComment(val);
    }
  };

  //when alert comment success clicks
  const onSubmitAlertComment = () => {
    let model = {
      is_resolved: isResolved,
      pk_list: [alertID],
      comment: alertComment,
    };

    ResolveAlertComments(token, model)
      .then((res) => {
        const data = res?.data || null;
        if (data) {
          if (data?.data?.is_success) {
            handleToggleAlertInput();
            let alertsInd = alertIndex;
            if (alertsArray.length > 0) {
              if (alertsInd < alertsArray.length - 1) {
                setAlertIndex(alertsInd + 1);
              } else {
                setAlertIndex(0);
              }
            } else {
              setAlertIndex(0);
            }
            getShipmentAlerts();
            fetchSingleShipmentData();
          } else {
            message.error(data?.data?.message);
          }
        }
      })
      .catch((error) => {
        unauthorize(error);
      })
      .finally(() => {
        hideSpin();
      });
  };
  const handleLightModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setLightModalOpen(true);
    }
  };
  const handleHumidityModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setHumidityModalOpen(true);
    }
  };

  const handleTempratureModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setTempratureModalOpen(true);
    }
  };

  const handleBatteryModal = () => {
    if (shipment?.shipment_monitor && shipment?.shipment_monitor?.length > 0) {
      setBatteryModalOpen(true);
    }
  };
  // archive options
  const items = [
    {
      key: "archive_shipment",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            alignItems: "center",
          }}
        >
          <ArchiveIcon size={12} />
          <span
            style={{
              marginLeft: "8px",
              paddingRight: "16px",
              fontSize: "12px",
            }}
          >
            {" "}
            Archive shipment
          </span>
        </span>
      ),
    },
    {
      key: "mark_as_delivered",
      label: (
        <span
          style={{
            display: "flex",
            alignItems: "center",
            alignItems: "center",
          }}
        >
          <CheckmarkIcon size={12} />
          <span
            style={{
              marginLeft: "8px",
              paddingRight: "16px",
              fontSize: "12px",
            }}
          >
            {" "}
            Mark as delivered
          </span>
        </span>
      ),
    },
  ];

  //   confirm archive modal
  const handleDeleteShipmentModal = () => {
    let model = {
      shipment_id: shipmentId,
    };
    ArchiveShipment(model, token).then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          toggleDrawer("close");
          shipmentSuccess();
          setDeleteShipmentModalOpen(false);
          message.success(data?.data?.message);
        } else {
          message.error(data?.data?.message);
        }
      }
    });
  };

  //   mark as delivered shipment
  const handleMarkAsDevliered = () => {
    let model = {
      shipment_id: shipmentId,
    };
    MarkAsDelivered(token, model).then((res) => {
      const data = res?.data ? res.data : null;
      if (data) {
        if (data?.data?.is_success) {
          toggleDrawer("close");
          shipmentSuccess();
          message.success(data?.data?.message);
        } else {
          message.error(data?.data?.message);
        }
      }
    });
  };

  //  menu seleced from archive dropdown
  const handleMenuClick = (e) => {
    if (e.key === "archive_shipment") {
      setDeleteShipmentModalOpen(true);
    } else {
      handleMarkAsDevliered();
    }
  };

  return (
    <>
      {/* <GoogleMapsProvider> */}
      {/* <div className={`custom-card-drawer ${isOpen ? "open" : ""}`}> */}
      <Flex vertical={true} gap={24}>
        <Flex
          gap={16}
          justify="space-between"
          align="center"
          className="custom-card-drawer-header"
          style={{marginBottom: alertsArray?.length > 0 ? '0px' : '16px'}}
        >
          <Row>
            <Col>
              <CustomTitle
                text="Reference ID"
                fontSize={10}
                color="#5E5E5E"
                fontWeight={600}
                lineHeight={"16px"}
                marginBottom={"0px"}
              />
              <CustomTitle
                text={shipment?.reference_number || ""}
                fontSize={18}
                fontWeight={700}
                lineHeight="24px"
                marginTop={"0px"}
                color="#000"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Flex
            gap={6}
            align="center"
            className="custom-card-drawer-header-actions"
          >
            <CircleGroup viewers={viewers} />
            <span title="Expand map" onClick={goToExternalView} style={{padding:"4px"}} >
              <FullscreenOutlined color="#000" style={{ fontSize: "14px", color: "#000" }}  />
            </span>

            <span title="Share" onClick={handleShareShipmentModal} style={{padding:"4px"}}>
              <img src={ShareIcon} alt=""  style={{ width: "16px", height: "16px" }}  />
            </span>

            {decodedToken?.role?.toLowerCase() !== "viewer" && (
              <>
                <span title="Edit" onClick={handleEditShipmentModal} style={{padding:"4px"}}>
                  <img src={EditIcon} alt=""  style={{ width: "16px", height: "16px" }}  />
                </span>

                <Dropdown
                  menu={{ items, onClick: handleMenuClick }}
                  trigger={["click"]}
                  placement="bottomRight"
                >
                  <span title="Archive" style={{ padding:"4px" }} >
                    <img src={ArchiveOptionsIcon} alt=""  style={{ width: "16px", height: "16px" }}   />
                  </span>
                </Dropdown>
              </>
            )}
            {/* <span title='Archive' onClick={handleDeleteShipmentModal}>
                            <img src={ArchiveOptionsIcon} alt='' />
                        </span> */}

            <span
              title="Close"
              className="no-bg" style={{ padding:"4px" }} 
              onClick={() => toggleDrawer("close")}
            >
              <CloseOutlined color="#000" style={{ fontSize: "14px", color: "#000" }}  />
            </span>
          </Flex>
        </Flex>
        {/* {alertsArray?.length>0 && (
                    altersArray.map((alert)=>{
                        return (
                            {alert?.alert_type === 1 && (
                                <StatusCardNotification
                                    cardStyle={"style-2"}
                                    icon={<WarningFilled style={{ color: "#fff" }} />}
                                    title={alertsData?.title || ""}
                                    description={alertsData?.detail || ""}
                                    bgColor="#DE1135"
                                    color={"#fff"}
                                    actionButtonText={"Mark as Resolved"}
                                    actionButtonWidth="112px"
                                    actionButtonBorderRadius="8px"
                                    actionButtonBgColor="#BB032A"
                                    dismissAction={() => { handleAlertResolved(false, alertsData?.id) }}
                                    actionButtonOnClick={() => { handleAlertResolved(true, alertsData?.id) }}
                                />
                            )}
                            {alert?.alert_type === 0 && (
                                <StatusCardNotification
                                    cardStyle={"style-2"}
                                    icon={<WarningFilled />}
                                    title={alertsData?.title || ""}
                                    description={alertsData?.detail || ""}
                                    bgColor="#F6BC2F"
                                    color={"#000"}
                                    actionButtonText={"Mark as Resolved"}
                                    actionButtonWidth="112px"
                                    actionButtonBorderRadius="8px"
                                    actionButtonBgColor="#FBE5B6"
                                    dismissAction={() => { handleAlertResolved(false, alertsData?.id) }}
                                    actionButtonOnClick={() => { handleAlertResolved(true, alertsData?.id) }}
                                />
                            )}
                        )
                    })
                )} */}
        {alertsArray?.length > 0 &&
          alertsArray.map((alert, index) => {
            return (
              <React.Fragment key={alert.id}>
                {alertIndex === index && (
                  <>
                    {/* {alert?.is_critical === true && (
                                            <StatusCardNotification
                                                cardStyle={"style-2"}
                                                icon={<WarningFilled style={{ color: "#fff" }} />}
                                                title={alert?.title || ""}
                                                description={alert?.detail || ""}
                                                bgColor="#DE1135"
                                                color={"#fff"}
                                                actionButtonText={"Mark as Resolved"}
                                                actionButtonWidth="112px"
                                                actionButtonBorderRadius="8px"
                                                actionButtonBgColor="#BB032A"
                                                dismissAction={() => handleAlertResolved(false, alert.alert?.id)}
                                                actionButtonOnClick={() => handleAlertResolved(true, alert.alert?.id)}
                                            />
                                        )} */}
                    <StatusCardNotification
                      cardStyle={"style-2"}
                      icon={<WarningFilled />}
                      title={alert?.title || ""}
                      description={alert?.detail || ""}
                      createdAt={alert?.created_at || ""}
                      bgColor={
                        alert?.is_critical === false ? "#F6BC2F" : "#DE1135"
                      }
                      color={alert?.is_critical === false ? "#000" : "#fff"}
                      actionButtonText={"Mark as Resolved"}
                      actionButtonWidth="112px"
                      actionButtonBorderRadius="8px"
                      actionButtonBgColor={
                        alert?.is_critical === false ? "#FBE5B6" : "#BB032A"
                      }
                      dismissAction={() =>
                        handleAlertResolved(false, alert?.id)
                      }
                      actionButtonOnClick={() =>
                        handleAlertResolved(true, alert?.id)
                      }
                    />

                    {alertsArray.length > 0 && (
                      <Flex
                        style={{ marginTop: "-18px" }}
                        justify="space-between"
                        align="center"
                        className="custom-card-drawer-header"
                      >
                        <p
                          style={{
                            color: "#000",
                            marginBottom: "0px",
                            fontSize: "12px",
                          }}
                        >
                          {alertIndex + 1} of {alertsArray.length} issues
                        </p>
                        <Flex
                          gap={8}
                          align="center"
                          className="custom-card-drawer-header-actions"
                        >
                          <button
                            style={{ border: 0, borderRadius: "50px" }}
                            title="Previous Alert"
                            onClick={() => {
                              if (alertIndex > 0) {
                                setAlertIndex(alertIndex - 1); // Decrease the alertIndex by 1
                              }
                            }}
                          >
                            <LeftOutlined
                              style={{
                                fontSize: "12px",
                                color: index === 0 ? "#AFAFAF" : "#000",
                              }}
                            />
                          </button>

                          <button
                            style={{ border: 0, borderRadius: "50px" }}
                            title="Next Alert"
                            onClick={() => {
                              if (alertIndex < alertsArray.length - 1) {
                                setAlertIndex(alertIndex + 1); // Decrease the alertIndex by 1
                              }
                            }}
                          >
                            <RightOutlined
                              style={{
                                fontSize: "12px",
                                color:
                                  index === alertsArray.length - 1
                                    ? "#AFAFAF"
                                    : "#000",
                              }}
                            />
                          </button>
                        </Flex>
                      </Flex>
                    )}
                  </>
                )}
              </React.Fragment>
            );
          })}

        <>
          {openAlertInput && (
            <div>
              <>
                <ShipmentCommentBox
                  onTextareaChange={onAlertTextareaChange}
                  error={commentsInputError}
                />
                <div>
                  <Flex gap={16}>
                    <CustomButton
                      text={"Cancel"}
                      width="70px"
                      height="36px"
                      fontSize="12px"
                      fontWeight="600"
                      lineHeight="16px"
                      borderRadius="8px"
                      bgColor="#F3F3F3"
                      color="#000"
                      boxShadow="none"
                      onClick={handleToggleAlertInput}
                      iconPosition="left"
                      gap={8}
                    />
                    <CustomButton
                      text={"Submit comment"}
                      width="147px"
                      height="36px"
                      fontSize="12px"
                      fontWeight="600"
                      lineHeight="16px"
                      borderRadius="8px"
                      bgColor="#000"
                      color="#fff"
                      boxShadow="none"
                      onClick={() => onSubmitAlertComment()}
                      iconPosition="left"
                      gap={8}
                    />
                  </Flex>
                </div>
              </>
            </div>
          )}
        </>

        <Row gap={24} justify="space-between" style={{ marginTop: "-20px" }}>
          <Col span={11}>
            <CustomParagraph
              text={"Delivery status"}
              fontSize={12}
              fontWeight={600}
              lineHeight="20px"
              color="#000"
              marginBottom="4px"
            />
            <Tag
              color={
                shipment?.delivery_status?.toLowerCase().includes("on time") ||
                shipment?.delivery_status?.toLowerCase() === "delivered"
                  ? "#EAF6ED"
                  : shipment?.delivery_status?.includes("Late")
                  ? "#FFF0EE"
                  : "rgb(243, 243, 243)"
              }
              style={{
                borderRadius: "8px",
                color:
                  shipment?.delivery_status?.toLowerCase() === "on time" ||
                  shipment?.delivery_status?.toLowerCase() === "delivered"
                    ? "#0E8345"
                    : shipment?.delivery_status?.includes("Late")
                    ? "#DE1135"
                    : "rgb(75, 75, 75)",
                fontSize: "10px",
              }}
            >
              {shipment?.delivery_status}
            </Tag>
            {/* // <Tag color={TagColor[shipment?.type]} style={{ borderRadius: "8px", color: TextColor[shipment?.type], fontSize: '10px' }}>
                        //     {(shipment?.type == 0 || shipment?.type == 4) && <ExclamationCircleFilled color={TextColor[shipment?.type]} style={{ marginRight: "4px" }} />}
                        //     {(shipment?.type == 1) && <WarningOutlined color={TextColor[shipment?.type]} style={{ marginRight: "4px" }} />}
                        //     {(shipment?.type == 2 || shipment?.type == 3) && <CheckCircleOutlined color={TextColor[shipment?.type]} style={{ marginRight: "4px" }} />
                        //     }
                        //     {shipment?.status}
                        // </Tag> */}

            {/* <CustomParagraph text={shipment?.delivery_status} fontSize={14} fontWeight={400} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
            {/* <CustomParagraph text={shipment?.shipment_details?.destination?.address} fontSize={14} fontWeight={400} lineHeight="20px" color="#4B4B4B" marginBottom="0" /> */}
          </Col>

          <Col span={11}>
            <CustomParagraph
              text={shipment?.type === 3 ? "Delivered on" : "ZoomLogi ETA"}
              fontSize={12}
              fontWeight={600}
              lineHeight="20px"
              color="#000"
              marginBottom="4px"
            />

            <CustomParagraph
              text={
                shipment?.type === 3
                  ? shipment?.actual_delivery_date
                  : shipment?.transport_provider_eta
              }
              fontSize={12}
              fontWeight={400}
              lineHeight="16px"
              color="#4B4B4B"
              marginBottom="0"
            />
          </Col>
          {/* <Col
            span={24}
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              margin: "5px 0",
            }}
          ></Col> */}
        </Row>

        <div className="">
          {/* <div style={{display:"flex",justifyContent:"end",alignItems:"center" ,marginBottom:"10px"}}>
                            <CustomButton
                                text={"Expand Map"}
                                width="147px"
                                height="36px"
                                fontSize="14px"
                                fontWeight="500"
                                lineHeight="16px"
                                borderRadius="8px"
                                bgColor="#F3F3F3"
                                color="#000"
                                boxShadow="none"
                                onClick={goToExternalView}
                                iconPosition="left"
                                gap={8}
                                icon={<FullscreenOutlined color="#000" />}
                            />
                        </div> */}
          <div className="map-container is-detail-shipment-map">
            <GoogleMapsProvider>
              <ShipmentMap
                currentView="summary"
                lastCoordinates={lastPoint}
                shipment={shipment}
                height={"260px"}
                isLargeScreen={false}
              />
            </GoogleMapsProvider>
          </div>
        </div>

        <Flex vertical={true} gap={20}>
          <Flex justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Shipment details"}
              fontSize={18}
              fontWeight={700}
              lineHeight="24px"
              color="#000"
              marginBottom="0"
            />

            <Flex gap={8}>
              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Temperature sensor reading  </span> <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={<img src={tempratureIcon} alt="" />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                  }}
                  onClick={handleTempratureModal}
                >
                  {shipment?.monitor_info?.temperature
                    ? parseInt(shipment?.monitor_info?.temperature) || 0
                    : 0}
                  °C
                </Tag>
              </Tooltip>

              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Sensor battery life</span>  <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={<img src={batteryIcon} alt="" />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                  }}
                  onClick={handleBatteryModal}
                >
                  {shipment?.monitor_info?.battery
                    ? parseInt(shipment?.monitor_info?.battery) || 0
                    : 0}
                  %
                </Tag>
              </Tooltip>

              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Light sensor reading</span> <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={<img src={lightIcon} alt="" />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                  }}
                  onClick={handleLightModal}
                >
                  {shipment?.monitor_info?.light
                    ? parseInt(shipment?.monitor_info?.light) || 0
                    : 0}
                  lx
                </Tag>
              </Tooltip>

              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: `<span>Humidity sensor reading</span> <br/> ${
                        shipment?.monitor_info?.timestamp || ""
                      } `,
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={<img src={humidityIcon} alt="" />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                  }}
                  onClick={handleHumidityModal}
                >
                  {shipment?.monitor_info?.humidity
                    ? parseInt(shipment?.monitor_info?.humidity) || 0
                    : 0}
                  %
                </Tag>
              </Tooltip>

              <Tooltip
                placement="top"
                title={
                  <p
                    className="fw-semibold"
                    dangerouslySetInnerHTML={{
                      __html: "<span>Viable transit time remaining</span>",
                    }}
                  />
                }
                arrow={true}
              >
                <Tag
                  icon={<img src={time} alt="" />}
                  style={{
                    margin: "0",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-start",
                    gridGap: "3px",
                    cursor: "pointer",
                    height: "20px",
                    padding: "0 4px",
                    minWidth: "20px",
                    backgroundColor: "#EAF6ED",
                    border: "none",
                    color: "#0E8345",
                  }}
                >
                  {changeToTimeString(shipment?.schedule_viability_window)}
                </Tag>
              </Tooltip>
            </Flex>
          </Flex>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Origin"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={[shipment?.from_location?.name]
                  .filter(Boolean)
                  .join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.from_location?.parsed_address?.AddressNumber,
                  shipment?.from_location?.parsed_address?.StreetName,
                  shipment?.from_location?.parsed_address?.StreetNamePostType,
                ]
                  .filter(Boolean)
                  .join(" ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.from_location?.parsed_address?.PlaceName,
                  shipment?.from_location?.parsed_address?.StateName,
                  shipment?.from_location?.parsed_address?.ZipCode ||
                    shipment?.from_location?.parsed_address
                      ?.SubaddressIdentifier,
                ]
                  .filter(Boolean)
                  .join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Destination"}
                fontSize={12}
                fontWeight={600}
                lineHeight="20px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={[shipment?.to_location?.name].filter(Boolean).join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.to_location?.parsed_address?.AddressNumber,
                  shipment?.to_location?.parsed_address?.StreetName,
                  shipment?.to_location?.parsed_address?.StreetNamePostType,
                ]
                  .filter(Boolean)
                  .join(" ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="4px"
              />
              <CustomParagraph
                text={[
                  shipment?.to_location?.parsed_address?.PlaceName,
                  shipment?.to_location?.parsed_address?.StateName,
                  shipment?.to_location?.parsed_address?.ZipCode ||
                    shipment?.to_location?.parsed_address?.SubaddressIdentifier,
                ]
                  .filter(Boolean)
                  .join(", ")}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Scheduled pickup"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.scheduled_pickup_date}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Scheduled delivery"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.scheduled_delivery_date}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Total weight (kg)"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.weight_kg}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Dimensions"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={
                  shipment?.volume
                    ? `${shipment.volume} Inch`
                    : "0 L x 0 W x 0 H Inch"
                }
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Total commercial value"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.total_commercial}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Reference ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.reference_number}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Flex justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Product details"}
              fontSize={18}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="0"
            />
          </Flex>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Product"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={capitalize(shipment?.product?.name)}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Product quantity"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.product?.quantity}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Product type"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.product?.product_type}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
            <Col span={11}>
              <CustomParagraph
                text={"Project ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.product?.project_id}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>
          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Temperature range"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.product?.temperature_range}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Transit viability window"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.product?.viability_window + " hrs"}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Sensor"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.sensor?.type ? shipment?.sensor?.type : "N/A"}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Sensor ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.sensor?.id}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Flex justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Transport provider"}
              fontSize={18}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="0"
            />
          </Flex>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Transport provider"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.courier?.title}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Contact phone"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.contact_phone}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Row gap={24} justify="space-between">
            <Col span={11}>
              <CustomParagraph
                text={"Tracking ID"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.courier_tracking_id}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>

            <Col span={11}>
              <CustomParagraph
                text={"Transport provider ETA"}
                fontSize={12}
                fontWeight={600}
                lineHeight="16px"
                color="#000"
                marginBottom="4px"
              />

              <CustomParagraph
                text={shipment?.transport_provider_eta}
                fontSize={12}
                fontWeight={400}
                lineHeight="16px"
                color="#4B4B4B"
                marginBottom="0"
              />
            </Col>
          </Row>

          <Flex wrap justify="space-between" align="center" gap={16}>
            <CustomTitle
              text={"Live chain custody"}
              fontSize={18}
              fontWeight={700}
              lineHeight="28px"
              color="#000"
              marginBottom="0px"
            />
            <Flex wrap gap={10}>
              {!openCommentInput && (
                <CustomButton
                  text="Upload File"
                  width="130px"
                  height="36px"
                  fontSize="12px"
                  fontWeight="600"
                  lineHeight="20px"
                  borderRadius="8px"
                  bgColor="#F3F3F3"
                  color="#000"
                  boxShadow="none"
                  imageWidth="17px"
                  onClick={() => setUploadModalOpen(true)}
                  iconPosition="left"
                  gap={8}
                  image={UploadIcon}
                />
              )}
              <FileUploadModal
                fetchSingleShipmentData={fetchSingleShipmentData}
                token={token}
                shipmentId={shipmentId}
                modalOpen={uploadModalOpen}
                setModalOpen={setUploadModalOpen}
              />
              {!openCommentInput && (
                <CustomButton
                  text={"Add comment"}
                  width="147px"
                  height="36px"
                  fontSize="12px"
                  fontWeight="600"
                  lineHeight="20px"
                  borderRadius="8px"
                  bgColor="#F3F3F3"
                  color="#000"
                  boxShadow="none"
                  onClick={onAddCommentClick}
                  iconPosition="left"
                  gap={8}
                  image={CommentIcon}
                />
              )}
            </Flex>
            {openCommentInput && (
              <div>
                <Flex gap={16}>
                  <CustomButton
                    text={"Cancel"}
                    width="70px"
                    height="36px"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="16px"
                    borderRadius="8px"
                    bgColor="#F3F3F3"
                    color="#000"
                    boxShadow="none"
                    onClick={onCancelComments}
                    iconPosition="left"
                    gap={8}
                  />
                  <CustomButton
                    text={"Submit comment"}
                    width="147px"
                    height="36px"
                    fontSize="14px"
                    fontWeight="500"
                    lineHeight="16px"
                    borderRadius="8px"
                    bgColor="#000"
                    color="#fff"
                    boxShadow="none"
                    onClick={onSubmitComments}
                    iconPosition="left"
                    gap={8}
                  />
                </Flex>
              </div>
            )}
          </Flex>

          {openCommentInput && (
            <ShipmentCommentBox
              onTextareaChange={onTextareaChange}
              error={commentsInputError}
            />
          )}

          <div
            className="custom-timeline"
            style={{ position: "relative", paddingRight: "50px" }}
          >
            <Timeline mode="left">
              {shipment?.chain_of_custody?.map((custody, index) => (
                <Timeline.Item
                  key={index}
                  dot={
                    custody?.type == 1 ? (
                      <img
                        src={CommentIcon}
                        style={{ width: "20px", height: "20px" }}
                      />
                    ) : custody?.type == 3 && custody?.is_critical === 0 ? (
                      <img
                        src={AtRisk}
                        style={{ width: "20px", height: "20px" }}
                      />
                    ) : custody?.is_critical === 1 && custody?.type == 3 ? (
                      <Flex
                        align="center"
                        justify="center"
                        style={{
                          backgroundColor: "#DE1135",
                          borderRadius: "50%",
                          width: "26px",
                          height: "26px",
                        }}
                      >
                        <span style={{ fontSize: "13px", color: "white" }}>
                          <ExclamationCircleFilled />
                        </span>
                      </Flex>
                    ) : custody?.file && custody?.type === 4 ? (
                      <>
                        <img src={FileImg}></img>

                        <Flex
                          style={{
                            position: "absolute",
                            top: "-15px",
                            left: "395px",
                            padding: "8px",
                            zIndex: 1,
                          }}
                        >
                          <CustomButton
                            width="50px"
                            height="50px"
                            bgColor="#F3F3F3"
                            borderRadius="50px"
                            color="#000"
                            boxShadow="none"
                            border="none"
                            iconPosition="right"
                            onClick={() => downloadFile(custody?.file)}
                            image={FileDownload}
                          />
                        </Flex>
                      </>
                    ) : (
                      <div
                        style={{
                          backgroundColor: "#000",
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                        }}
                      />
                    )
                  }
                >
                  <CustomParagraph
                    text={String(custody?.action || "")}
                    fontSize={12}
                    fontWeight={600}
                    lineHeight="16px"
                    color="#000"
                    marginBottom="10px"
                  />
                  <CustomParagraph
                    text={String(custody?.comment || "")}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="4px"
                  />
                  <CustomParagraph
                    text={String(custody?.location || "")}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="4px"
                  />
                  <CustomParagraph
                    text={String(custody?.timestamp || "")}
                    fontSize={12}
                    fontWeight={400}
                    lineHeight="16px"
                    color="#4B4B4B"
                    marginBottom="0"
                  />
                  {custody?.alert_completion && (
                    <Row style={{ marginTop: "12px", marginBottom: "12px" }}>
                      <Col
                        span={4}
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          alignItems: "center",
                          marginRight: "20px",
                        }}
                      >
                        {custody?.alert_completion?.status == "Resolved" ? (
                          <Flex
                            align="center"
                            justify="center"
                            style={{
                              backgroundColor: "#0E8345",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                            }}
                          >
                            <span style={{ fontSize: "15px", color: "white" }}>
                              <CheckOutlined />
                            </span>
                          </Flex>
                        ) : (
                          <Flex
                            align="center"
                            justify="center"
                            style={{
                              backgroundColor: "#000",
                              borderRadius: "50%",
                              width: "20px",
                              height: "20px",
                            }}
                          >
                            <span style={{ fontSize: "15px", color: "white" }}>
                              <MinusOutlined />
                            </span>
                          </Flex>
                        )}
                      </Col>
                      <Col>
                        <CustomParagraph
                          text={
                            (custody?.alert_completion?.status == "Resolved"
                              ? "Resolved by"
                              : "Dismissed by") +
                            " " +
                            String(custody?.alert_completion?.name || "")
                          }
                          fontSize={12}
                          fontWeight={600}
                          lineHeight="16px"
                          color="#000"
                          marginBottom="0px"
                        />
                        <CustomParagraph
                          text={String(
                            custody?.alert_completion?.comment || ""
                          )}
                          fontSize={12}
                          fontWeight={400}
                          lineHeight="16px"
                          color="#4B4B4B"
                          marginBottom="4px"
                        />
                        <CustomParagraph
                          text={String(
                            custody?.alert_completion?.completed_at || ""
                          )}
                          fontSize={12}
                          fontWeight={400}
                          lineHeight="16px"
                          color="#4B4B4B"
                          marginBottom="0"
                        />
                      </Col>
                    </Row>
                  )}
                </Timeline.Item>
              ))}
            </Timeline>
          </div>
        </Flex>
      </Flex>
      {/* </div> */}
      {/* </GoogleMapsProvider> */}

      {shareShipmentModalOpen && (
        <CustomModalWithoutButton
          modalOpen={shareShipmentModalOpen}
          setModalOpen={setShareShipmentModalOpen}
          modalTitle="Share shipment"
          modalText=""
          modalSize={524}
          buttonText1=""
          buttonText2=""
          onConfirmClick={() => console.log("Share Shipment")}
        >
          <ShareShipment shipmentId={shipmentId} token={token} />
        </CustomModalWithoutButton>
      )}

      {deleteShipmentModalOpen && (
        <CustomModalWithoutButton
          modalOpen={deleteShipmentModalOpen}
          setModalOpen={setDeleteShipmentModalOpen}
          modalTitle="Archive Shipment"
          modalText=""
          modalSize={524}
          buttonText1=""
          buttonText2=""
          onConfirmClick={() => console.log("Share Shipment")}
        >
          <Flex vertical={true} gap={20}>
            <CustomParagraph text="Stop tracking this shipment on ZoomLogi." />

            <Flex gap="16px" justify="end">
              <CustomButton
                text={"Cancel"}
                bgColor="transparent"
                color="black"
                fontSize="16px"
                fontWeight="500"
                boxShadow="none"
                height="48px"
                onClick={() => setDeleteShipmentModalOpen(false)}
              />
              <CustomButton
                text={"Archive Shipment"}
                bgColor="#DE1135"
                color="white"
                width="154px"
                fontSize="16px"
                fontWeight="500"
                boxShadow="none"
                borderRadius="8px"
                htmlType="submit"
                onClick={() => handleDeleteShipmentModal()}
              />
            </Flex>
          </Flex>
        </CustomModalWithoutButton>
      )}
      {humidityModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={humidityModalOpen}
            setModalOpen={setHumidityModalOpen}
            modalTitle="Humidity"
            modalText=""
            modalSize={715}
          >
            <HumidityModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}

      {lightModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={lightModalOpen}
            setModalOpen={setLightModalOpen}
            modalTitle="Light"
            modalText=""
            modalSize={715}
          >
            <LightModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}

      {tempratureModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={tempratureModalOpen}
            setModalOpen={setTempratureModalOpen}
            modalTitle="Temperature"
            modalText=""
            modalSize={715}
          >
            <TemperatureModal
              min={shipment?.product?.temperature_min}
              max={shipment?.product?.temperature_max}
              shipment_monitor={shipment?.shipment_monitor}
            />
          </CustomModalWithoutButton>
        )}

      {batteryModalOpen &&
        shipment?.shipment_monitor &&
        shipment?.shipment_monitor?.length > 0 && (
          <CustomModalWithoutButton
            modalOpen={batteryModalOpen}
            setModalOpen={setBatteryModalOpen}
            modalTitle="Sensor battery life"
            modalText=""
            modalSize={715}
          >
            <BatteryModal shipment_monitor={shipment?.shipment_monitor} />
          </CustomModalWithoutButton>
        )}
    </>
  );
}

export default ShipmentDetailDrawer;
